import * as notification from '../../components/notifications';
import trans from "../../utils/trans";
import {showFormErrors} from "../../utils/form";

let selectedEmployerProductId = null;
let cardElements = null;
let stripeInstance = null;
let selectedEmployerProductIsInTrial = null;

const initPage = () => {
  initCancellationReasons();

  $(".btn-view-product-information, .employer-product-name").click(function () {
    viewProductInformation(this);
    return false;
  });

  $(".btn-cancel-subscription").click(function () {
    const employerProductId = $(this).data('employerProductId');
    askToCancelSubscription(employerProductId, false)
    return false;
  });

  $(".btn-cancel-trial").click(function () {
    const employerProductId = $(this).data('employerProductId');
    askToCancelSubscription(employerProductId, true)
    return false;
  });

  $(".btn-update-payment-method").click(function () {
    const selectedEmployerProductId = $(this).data('employerProductId');
    askToUpdatePaymentMethod(selectedEmployerProductId)
    return false;
  });

  $(".btn-resume-subscription").click(function () {
    const employerProductId = $(this).data('employerProductId');
    askToResumeSubscription(employerProductId)
    return false;
  });

  $("#modal-cancel-subscription .btn-modal-confirm, #modal-cancel-trial .btn-modal-confirm").click(function () {
    cancelSelectedSubscription($(this))
    return false;
  });

  $("#modal-resume-subscription .btn-modal-confirm").click(function () {
    resumeSelectedSubscription()
    return false;
  });

  $("#modal-update-payment-method .btn-modal-confirm").click(function () {
    updateSubscriptionPaymentMethod()
    return false;
  });
};

const askToCancelSubscription = (id, inTrial) => {
  selectedEmployerProductId = id;
  selectedEmployerProductIsInTrial = inTrial;
  resetCancellationReasons();
  inTrial ? $('#modal-cancel-trial').modal('show') : $('#modal-cancel-subscription').modal('show');

};

const askToResumeSubscription = (id) => {
  selectedEmployerProductId = id;
  $('#modal-resume-subscription').modal('show');
};

const askToUpdatePaymentMethod = (employerProductId) => {
  selectedEmployerProductId = employerProductId;
  initPaymentForm()
  hideCardError();
  $('#modal-update-payment-method').modal('show');
};

const viewProductInformation = (self) => {
  const productItemDescription = $(self).parents('.item-row').data('productItemDescription');

  $('#modal-product-information').modal('show');
  $('#modal-product-information .modal-body').html(productItemDescription);
};

const cancelSelectedSubscription = async (target) => {
  let cancelButton = target;
  cancelButton.loading(true);

  try {
    await axios.delete("/api/employer_products/" + selectedEmployerProductId + "/subscriptions",
      {data: getCancellationReasonData()}
    );

    notification.success(trans('employer_account.products.message.canceled_successfully'));
    $('#modal-cancel-subscription').modal('hide');

    setTimeout(function () {
      location.reload();
    }, 1000);
  } catch (e) {
    cancelButton.loading(false);

    if (e?.response?.status === 422) {
      showFormErrors($('form', getCancellationReasonsContainerElement()), e.response);
    } else {
      notification.danger(e.response.data.message);
      $('#modal-cancel-subscription').modal('hide');
    }
  }
};

const resumeSelectedSubscription = async () => {
  let cancelButton = $("#modal-resume-subscription .btn-modal-confirm");
  cancelButton.loading(true);

  try {
    await axios.post("/api/employer_products/" + selectedEmployerProductId + "/subscriptions");

    notification.success(trans('employer_account.products.message.resumed_successfully'));
    $('#modal-resume-subscription').modal('hide');

    setTimeout(function () {
      location.reload();
    }, 1000);
  } catch (e) {
    cancelButton.loading(false);
    $('#modal-resume-subscription').modal('hide');
    notification.danger(e.response.data.message);
  }
};

const updateSubscriptionPaymentMethod = async () => {
  let confirmButton = $("#modal-update-payment-method .btn-modal-confirm");
  confirmButton.loading(true);

  const sourceResult = await getStripe().createSource(cardElements);

  if (sourceResult.error) {
    confirmButton.loading(false);
    showCardError(sourceResult.error.message);
  } else {
    try {
      await axios.patch("/api/employer_products/" + selectedEmployerProductId + "/update-payment-method", sourceResult)

      notification.success(trans('employer_account.products.message.payment_method.updated'));
      $('#modal-update-payment-method').modal('hide');
      confirmButton.loading(false);

    } catch (e) {
      confirmButton.loading(false);
      $('#modal-update-payment-method').modal('hide');
      notification.danger(e.response.data.message);
    }
  }
};

const getStripe = () => {
  if (!stripeInstance) {
    stripeInstance = Stripe($jBoard.payments.stripe.key, {
      stripeAccount: $jBoard.payments.stripe.account_id,
    });
  }

  return stripeInstance;
};

const initPaymentForm = () => {
  if (isStripeConfigured()) {
    const formsControlStyles = $theme.$styleGroupsCssObjectMap.formsControl;
    const elements = getStripe().elements();

    // Define the base font size of the document
    const baseFontSize = 16; // Change this value if your base font size is different

    // Calculate the total lineHeight by adding paddingTop and paddingBottom to lineHeight, converting from rem to px
    const totalLineHeight = (parseFloat(formsControlStyles.fontSize.replace('rem', '')) +
      parseFloat(formsControlStyles.paddingTop.replace('rem', '')) +
      parseFloat(formsControlStyles.paddingBottom.replace('rem', ''))) * baseFontSize + 'px';

    const style = {
      base: {
        color: formsControlStyles.color,
        fontWeight: formsControlStyles.fontWeight,
        fontFamily: formsControlStyles.fontFamily,
        fontSize: formsControlStyles.fontSize,
        lineHeight: totalLineHeight,
        letterSpacing: formsControlStyles.letterSpacing,
        iconColor: formsControlStyles.color,
        '::placeholder': {
          color: $theme.input.placeholderColor,
        }
      },
      invalid: {
        color: $theme.colors.danger,
        iconColor: $theme.colors.danger,
      }
    };

    const card = elements.create("card", {style: style});
    card.mount("#card-element");

    card.on('change', ({error}) => {
      if (error) {
        showCardError(error.message);
      } else {
        hideCardError();
      }
    });

    cardElements = card;
  }
};

const showCardError = (message) => {
  const displayError = $('#card-errors');
  const cardElements = $('#card-element');

  displayError.text(message);
  displayError.show();
  cardElements.addClass('is-invalid');
};

const hideCardError = () => {
  const displayError = $('#card-errors');
  const cardElements = $('#card-element');

  displayError.hide();
  cardElements.removeClass('is-invalid');
};

const isStripeConfigured = () => {
  return $jBoard.payments.stripe.account_id !== null;
};

const initCancellationReasons = () => {

  [$('#trial-cancellation-reasons-container'), $('#not-trial-cancellation-reasons-container')].forEach((container) => {
    if (!container.length) {
      return;
    }
    const reasonSelectBox = $('#cancellation_option', container);
    const additionalDetailsContainer = $('#additional_details_container', container);

    reasonSelectBox.on('change', function () {
      const selectedOption = $(this).find('option:selected');
      const hasDetails = selectedOption.data('has-details');

      if (hasDetails) {
        additionalDetailsContainer.removeClass('d-none');
      } else {
        additionalDetailsContainer.addClass('d-none');
      }
    });
  })
}

const getCancellationReasonData = () => {
  const containerElement = getCancellationReasonsContainerElement();
  if (!containerElement) {
    return {}
  }

  return {
    'cancellation_option'  : $('#cancellation_option', containerElement).val(),
    'cancellation_comment' : $('textarea', containerElement).val()
  }
}

const resetCancellationReasons = () => {
  const containerElement = getCancellationReasonsContainerElement();
  if (!containerElement) {
    return;
  }

  const reasonSelectBox = $('#cancellation_option', containerElement);
  reasonSelectBox.val('');
  reasonSelectBox.selectpicker('refresh');
  $('textarea', containerElement).val('');
}

const getCancellationReasonsContainerElement = () => {
  let containerElement = selectedEmployerProductIsInTrial ? $('#trial-cancellation-reasons-container') : $('#not-trial-cancellation-reasons-container');
  if (containerElement.length) {
    return containerElement;
  }
  return null;
}

$(initPage);
